import React, { useEffect } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { updateStats, setOver, setPractice } from '../REDUX/actions';
import { goToPage, forceUpdate } from '../../HOME/REDUX/actions';
import {} from '../const';
import BackButton from '../COMPONENTS/BackButton';
import { Background } from '../COMPONENTS/Background';
import Logo from '../ASSETS/NumericaLogo.png';
import { windowSize, scrollClass } from '../../HOME/utils';
import { getAppInfo } from '../../HOME/info';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { GAME_PAGE } from '../../HOME/const';
import NumPad from '../COMPONENTS/NumPad';
import * as f from '../logic.js';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

const StartPage = props => {
  const { forceUpdate, updateStats } = props;

  useEffect(() => {
    window.addEventListener('resize', forceUpdate);

    f.getStats(stats => {
      updateStats(stats);
    });

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [forceUpdate, updateStats]);

  const handleMode = practice => {
    props.setPractice(practice ? 1 : 0);
    props.goToPage(GAME_PAGE);
  };

  const { x: wx, y: wy } = windowSize();
  const width = Math.min(wx, wy) / 7;
  const appName = getAppInfo(props.app).name;

  return (
    <div className="page-root">
      <div className="nm-page nm-help-page" style={{ backgroundImage: Background }}>
        <div className="ms-logo-title" style={{ gridArea: '1/1', position: 'inherit', justifySelf: 'start' }}>
          <img src={Logo} width={width} alt="Numerica logo" />
          <span className="nm-title">{appName}</span>
        </div>
        <div className={scrollClass} style={{ gridArea: '2/1', justifySelf: 'center', marginTop: '10px' }}>
          <div className="nm-help">
            <span style={{ gridArea: '1/1', overflow: 'auto' }}>
              Use the number pad at the bottom of the screen to compose and remove the number descending from the top. For example, 195 = 162 +
              27 + 6:
            </span>
            <span className="nm-help-numpad">
              <NumPad level={2} preSelected={[162, 27, 6]} />
            </span>
            <span style={{ gridArea: '5/1', overflow: 'auto' }}>
              You can select no more than one number from each column. Tap the 'X' below the number pad to clear all selections at once.
            </span>
            <span style={{ gridArea: '7/1', overflow: 'auto' }}>
              The numbers that are not removed are stacked at the bottom.{' '}
              <span style={{ color: 'pink' }}>You can still remove a number from the stack as long as it remains the top one.</span>
            </span>
            <span style={{ gridArea: '9/1', overflow: 'auto' }}>
              In the <span style={{ color: 'pink' }}>Compete</span> mode you have <span style={{ color: 'pink' }}>80 seconds per level</span> to
              remove as many numbers as possible. Your score depends on the total value of numbers removed.
            </span>
          </div>
        </div>
        <div className="nm-help-buttons">
          <div className="ms-start" style={{ gridArea: '1/1', marginRight: '20px' }} onClick={() => handleMode(true)}>
            PRACTICE
          </div>
          <div className="ms-start" style={{ gridArea: '1/2' }} onClick={() => handleMode(false)}>
            COMPETE
          </div>
        </div>
      </div>
      <BmgButton />
      <BackButton />
      <HomeButton />
    </div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { updateStats, goToPage, setOver, forceUpdate, setPractice }
)(StartPage);
